import type { APIEvent, TransportItem } from '@grafana/faro-web-sdk';

const RESOURCE_TIMING_EVENT = 'faro.performance.resource';

// Resource timings for these hosts are never read and cost ~190 MB/day of logs:
// LaunchDarkly analytics beacons, Google Fonts, and a Kaspersky extension.
const IGNORED_RESOURCE_HOSTS = new Set([
  'events.launchdarkly.com',
  'fonts.gstatic.com',
  'gc.kis.v2.scr.kaspersky-labs.com',
]);

function resourceHost(resourceUrl: string | undefined) {
  if (!resourceUrl) return undefined;
  try {
    return new URL(resourceUrl).hostname;
  } catch {
    return undefined;
  }
}

export function dropIgnoredResourceTimings(item: TransportItem<APIEvent>): TransportItem<APIEvent> | null {
  const { payload } = item;
  if (!('name' in payload) || payload.name !== RESOURCE_TIMING_EVENT) return item;

  const host = resourceHost(payload.attributes?.name);
  return host && IGNORED_RESOURCE_HOSTS.has(host) ? null : item;
}
